module.exports = __webpack_public_path__ + "img/instagram-update.ab2622c9.svg";